export default "__VITE_ASSET__51a73905__"